import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserType } from '@ps/core-models';

import {
  ProjectManager,
  Survey,
  SurveyTransactionStatus,
} from '@ps/survey-utils';
import { SurveyBuyerSettings } from '../survey-state.model';

export const SurveyReferenceActions = createActionGroup({
  source: 'Survey Reference',
  events: {
    'Load Buyer Managers': props<{ companyId: number }>(),
    'Load Operator Managers': emptyProps(),
    'Load Transaction Statuses': emptyProps(),
    'Load Buyer Settings': props<{ buyerId: number }>(),
    'Download Combined ST Report': props<{
      cmp: number;
      userType: UserType;
      surveys: Survey[];
      statuses: number[];
      includeTestTransactions: boolean;
    }>(),
    'Download Cs Report': props<{ surveyId: number }>(),
  },
});

export const SurveyReferenceApiActions = createActionGroup({
  source: 'Survey Reference API',
  events: {
    'Load Buyer Managers Success': props<{
      managers: ProjectManager[];
      cachedAt: number;
      companyId: number;
    }>(),
    'Load Buyer Managers Failure': props<{ error: string }>(),
    'Load Operator Managers Success': props<{
      managers: ProjectManager[];
      cachedAt: number;
    }>(),
    'Load Operator Managers Failure': props<{ error: string }>(),
    'Load Transaction Statuses Success': props<{
      statuses: SurveyTransactionStatus[];
      cachedAt: number;
    }>(),
    'Load Transaction Statuses Failure': props<{ error: string }>(),
    'Load Buyer Settings Success': props<{
      buyerSettings: SurveyBuyerSettings;
      cachedAt: number;
    }>(),
    'Load Buyer Settings Failure': props<{ error: string }>(),
    'Download Combined ST Report Success': emptyProps(),
    'Download Combined ST Report Failure': props<{ error: string }>(),
    'Download Cs Report Success': emptyProps(),
    'Download Cs Report Failure': props<{ error: string }>(),
  },
});
